import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('../views/Pages/Login.vue')
      },
    ]
  },
  {
    path: '/',
    redirect: 'dashboard',
    component: DashboardLayout,
    children: [
      {
        path: '/gestionUsuarios',
        name: 'gestionUsuarios',
        component: () => import('../views/Pages/UserProfile/GestionUsuarios.vue')
      },
      {
        path: '/profile',
        name: 'profile',
        component: () => import('../views/Pages/UserProfile/UserCard.vue')
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/Dashboard.vue')
      },
      {
        path: '/gestionCatecumenos',
        name: 'gestionCatecumenos',
        component: () => import('../views/GestionCatequesis/GestionCatecumenos.vue')
      },
      {
        path: '/groups',
        name: 'groups',
        component: () => import('../views/groupsView.vue')
      },
      {
        path: '/gestion_grupos',
        name: 'gestionGrupos',
        component: () => import('../views/GestionCatequesis/VistaPadreGestionCatequesis.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('../views/Pages/Register.vue')
      },
      { path: '*', component: NotFound }
    ]
  }
];

export default routes;
